<template>
  <div class="container">
		<div class="conmonContent">
			<div class="w1600">
				<div class="otDetail d-flex j-sb">
					<!-- 左侧详情 -->
					<div class="otLeftContent">
						<!-- 视频区 -->
						<div class="tVideo bd10 p3">
							<!-- <p class="font18">芯片级EDA及IP</p> -->
							<h3 class="font36 line-sm">{{content.details.title}}</h3>
							<div class="tagList">
								<i v-for="(item, index) in content.details.subGroup ? content.details.subGroup.split(',') : []">{{item}}</i><span class="font-light cor999"></span>
							</div>
							<div class="dImg">
								<img v-if="content.details.cover" :src="content.details.cover" alt="">
							</div>
						</div>
						<!-- 简介 -->
						<div class="intro bd10 p3">
							<div class="oTitle d-flex j-start">
								<h4 class="font-medium h4 font20">{{ $t('qa.brief') }}</h4>
							</div>
							<div class="desc font-light line-md" v-html="content.details.description"></div>
						</div>
						<!-- 详细信息  -->
						<div class="info bd10 p3 inDetail">
							<div class="oTitle d-flex j-start">
								<h4 class="font-medium h4 font20">{{ $t('qa.detail') }}</h4>
							</div>
							<div class="desc line-md font-light" v-html="content.details.content"></div>
						</div>
						<!-- 相关下载 -->
						<div class="download bd10 p3">
							<div class="oTitle d-flex j-start">
								<h4 class="font-medium h4 font20">{{ $t('qa.relateDownload') }}</h4>
							</div>
							<ul class="d-flex f-wrap">
								<li v-for="(item, index) in content.details.fileList" :key="index">
									<div class="item d-flex a-center j-sb"  @click="downloadFile(item.id,index)">
										<a class="t line-sm nowrap1 link">{{item.name}}</a>
										<div class="ar d-flex a-center j-end">
											<div class="downbar d-flex j-end" v-show="item.dp>0" style="margin-right: 10px;">
												<el-progress :percentage="item.dp" :show-text="true" :stroke-width="4"></el-progress>
											</div>
											<a class="d" ></a>
										</div>
									</div>
								</li>
							</ul>
						</div>
					</div>
					<!-- 右侧目录菜单 -->
					<div class="otRightMenu">
						<!-- 目录 -->
						<div class="directory bd10 p3">
							<div class="oTitle d-flex j-start">
								<h4 class="font-medium font18 h4">{{content.details.title}}</h4>
							</div>
							<ul>
								<li class="active pointer">{{ $t('qa.brief') }}</li>
								<li class="pointer">{{ $t('qa.detail') }}</li>
								<li class="pointer">{{ $t('qa.relateDownload') }}</li>
							</ul>
						</div>
						<!-- 相关问题 -->
						<div class="train bd10 p3">
							<div class="sTitle d-flex a-center j-sb">
								 <h3 class="font18 h3 font-medium">{{ $t('qa.relate') }}</h3>
							</div>
							<ul>
								<li v-for="(item, index) in content.other" :key="index">
									<h3 class="h3 line-sm nowrap2 font-light"><a @click="goToPage('/questionDetail?id='+item.id)" class="link pointer">{{item.title}}</a></h3>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>
  </div>
</template>

<script>
export default {
  name: 'QuestionDetail',
  components: {
    
  },
  data() {
    return {
		// 详细信息
		content: {
			details: {
				title: ''
			}
		}
	}
  },
  
  created() {
	  // 获取详细信息
	  this.getContentInfo(this.$route.query.id);
	 
  },
  
  mounted() {
	// 页面滚动对应位置右边对应信息高亮
	this.scrollTitleCurrent();
	// 右边信息点击页面滚动对应位置
	this.titleScrollPosition();
  },
  
  methods: {
	downloadFile(path,index){
      var that=this;
	  var id=that.$route.query.id;
      if(that.content.details.fileList[index].dp!=0){return;}
      that.content.details.fileList[index].dp=1;
      that.$daxios
        .get(`knowledge/downLog?id=${id}&path=${path}`,{
          responseType: 'blob',
          onDownloadProgress:e=>{
            that.content.details.fileList[index].dp=Math.floor(e.progress*100);
          },
        })
        .then((res) => {
          if(res.data&&res.data.size==0){
            that.content.details.fileList[index].dp=0;
            that.$message({
              message:"下载失败",
              type: 'error'
            });
			return;
          };
          const url = window.URL.createObjectURL(new Blob([res.data]),{ type: res.headers['content-type'] });
          const link = document.createElement('a');
          let fileName = res.headers['content-file-name'];
          link.href = url;
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          link.remove();
		  that.content.details.fileList[index].dp=0;
        })
        .catch((err) => { 
          that.content.details.fileList[index].dp=0;
        });
    },
	  // 页面跳转
	  goToPage(path, query={}) {
		  this.$router.push({
			path,
			query
		  })
	  },
	  
	  // 页面滚动对应位置右边对应信息高亮
	  scrollTitleCurrent() {
		  let detailTop = $('.inDetail').offset().top - 90;
		  let downloadTop = $('.download').offset().top - 90;
		$(window).on('scroll', function() {
			let scrollTop = $(this).scrollTop();
			if(scrollTop >= detailTop) {
				$('.directory ul li').eq(1).addClass('active').siblings().removeClass('active');
			}else if(scrollTop >= downloadTop) {
				$('.directory ul li').eq(2).addClass('active').siblings().removeClass('active');
			}else{
				$('.directory ul li').eq(0).addClass('active').siblings().removeClass('active');
			}
		})  
	  },
	  
	  // 右边信息点击页面滚动对应位置
	  titleScrollPosition() {
		  let detailTop = $('.inDetail').offset().top;
		  let downloadTop = $('.download').offset().top;
		  $('.directory ul li').click(function() {
			  let index = $(this).index();
			  if(index == 0) {
				  $('html,body').stop().animate({scrollTop: 0}, 800);
			  }else if(index == 1) {
				  $('html,body').stop().animate({scrollTop: detailTop}, 800);
			  }else{
				  $('html,body').stop().animate({scrollTop: downloadTop}, 800);
			  }
			  
		  })
	  },
	  
	  // 获取详细信息
	  getContentInfo(id) {
		  this.$axios.get(`knowledge/FAQDetails?id=${id}`)
		  .then(res => {
			  let data = res.data;
			  // 当前产品信息
			  res.data.details.fileList.forEach(i=>{i.dp=0});
			  this.content = data;
			  document.title = data.details.title;
		  })
		  .catch(err=>{})
	  }
  },
  
  // 监听
  watch: {
	  // 路由变化
	  '$route'(to, from) {
		  // 重新获取详细信息
		  this.getContentInfo(this.$route.query.id);
		  // 更新页面滚动对应位置右边对应信息高亮
		  this.scrollTitleCurrent();
			// 右边信息点击页面滚动对应位置
			this.titleScrollPosition();
	  } 
  }
}
</script>

<style lang="less" scoped>
	.otDetail{
		padding-top: .6rem;
		align-items: flex-start;
		.otLeftContent{
			width: calc(100% - 3.5rem);
		}
		.otRightMenu{
			width: 3.3rem;
			position: sticky;
			top: 0;
		}
		@media (max-width: 1200px) {
			flex-direction: column;
			.otLeftContent,
			.otRightMenu{
				width: 100%;
			}
				
			.otRightMenu{
				margin-top: .3rem;
				.directory{
					display: none;
				}
			}
		}
	}
	.otRightMenu{
		.directory{
			margin-bottom: .1rem;
			ul li{
				&:not(:last-child) {
					margin-bottom: .15rem;
				}
				&:hover,&.active{
					color: #3076e3;
				}
				
				a{
					width: 70%;
				}
			}
		}
		.train{
			ul li{
				padding: .15rem 0;
				&:nth-of-type(1) {
					padding-top: 0;
				}
				&:not(:last-child) {
					
					border-bottom: solid 1px #eee;
				}
			}
		}
	}
	.otLeftContent{
		& > div:not(:last-child){
			margin-bottom: .1rem;
		}
		.info{
			.desc{
				margin-top: .3rem;
			}
			dl dd{
				margin-top: .2rem;
				position: relative;
				padding-left: .2rem;
				&:after{
					content: "";
					position: absolute;
					left: 0;
					top: .03rem;
					width: .08rem;
					height: .08rem;
					border-radius: 50%;
					background: #45adf2;
				}
			}
		}
		.download{
			
			ul{
				margin: 0 -.1rem;
				margin-top: -.2rem;
				li{
					width: 50%;
					padding: 0 .1rem;
					margin-top: .2rem;
					.item{
						background: #f8f8f8;
						height: .6rem;
						padding: 0 .2rem;
					}
					.t{
						display: block;
						padding-left: .35rem;
						background: url(@/assets/Icons/pdf.png) no-repeat 0 center/.16rem;
						width: calc(100% - .35rem);
					}
					.d{
						width: .18rem;
						height: .18rem;
						background: url(@/assets/Icons/downloadHrefBlue.png) no-repeat 0 center/100% 100%;
					}
				}
			}
		}
		.intro{
			.desc{
				min-height: 1.5rem;
			}
		}
		.tVideo{
			.dImg{
				padding-top: .6rem;
				margin-top: .4rem;
				border-top: solid 1px #eee;
			}
			h3{
				margin: .1rem 0 .3rem;
			}
			i{
				margin-right: .2rem;
			}
		}
		@media (max-width: 640px) {
			.download{
				ul{
					li{
						width: 100%;
					}
				}
			}
		}
	}
</style>
